import {OptionTools} from "./option-tools.js";
import {FormElement} from "./form-element.js";
import {RadioElement} from "./radio-element.js";

/**
 * Represents a Radio Group element in a form. This class extends the FormElement class and is used to create and manage
 * a group of radio input elements.
 */
export class RadioGroupElement extends FormElement {
    options;

    /**
     * Constructs an instance of the class.
     *
     * @param {Object} formData - The data related to the form fields and values.
     * @param {HTMLElement} parentElement - The parent HTML element where the form will be rendered or attached.
     * @param {Array} collection - A collection or array containing associated items or data for the form.
     * @return {void}
     */
    constructor(formData, parentElement, collection) {
        super(formData, parentElement, collection);
    }

    /**
     * Sets the label for a specified wrapper by prepending a component label.
     *
     * @param {Object} wrapper - The wrapper element where the label will be appended.
     * @param {Object} component - The component to associate with the label.
     * @return {void} No return value.
     */
    setLabel(wrapper, component) {
        wrapper.prepend(this.componentLabel());
    }

    /**
     * Enhances a given wrapper element by adding a 'radio-group' class and rendering radio button options inside it.
     *
     * @param {HTMLElement} wrapper - The parent element where the radio options will be rendered.
     * @return {null} Returns null after rendering the radio options.
     */
    component(wrapper) {
        wrapper.classList.add('radio-group')
        this.noValue = false;
        const options = OptionTools.buildOptions(this, this.options, this.formData);
        options.forEach(option => {
            const radio = Object.assign(new RadioElement(this.formData, wrapper, this.collection), option);
            radio.parent = this;
            radio.render();
        });

        return null;
    }
}
